import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedinUser } from "helpers/api_helper";
import { useTranslation } from "react-i18next";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useTranslation("translation", { keyPrefix: "LAYOUT" });

  //state data

  const [isDashboard, setIsDashboard] = useState<boolean>(false);
  const [isAgent, setIsAgent] = useState<boolean>(false);
  const [isFileManagement, setIsFileManagement] = useState<boolean>(false);
  const [isFileViewer, setIsFileViewer] = useState<boolean>(false);
  const [isUsers, setIsUsers] = useState<boolean>(false);
  const [isNotification, setIsNotification] = useState<boolean>(false);

  // Pages
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems: any = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Agent") {
      setIsAgent(false);
    }
    if (iscurrentState !== "File Management") {
      setIsFileManagement(false);
    }
    if (iscurrentState !== "File Viewer") {
      setIsFileViewer(false);
    }
    if (iscurrentState !== "Users") {
      setIsUsers(false);
    }

    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
  }, [history, iscurrentState, isDashboard, isAgent, isFileManagement, isFileViewer, isUsers]);

  const user = getLoggedinUser();
  const memberMenuItems: any = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: `${t("MENU:DASHBOARD")}`,
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "file-viewer",
      label: `${t("MENU:FILE_VIEWER")}`,
      icon: "ri-file-text-line",
      link: "/apps-file-manager",
      stateVariables: isFileViewer,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("File Viewer");
      },
    },
    {
      id: "agent",
      label: `${t("MENU:AGENT")}`,
      icon: "ri-chat-1-line",
      link: "/chat",
      stateVariables: isAgent,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Agent");
      },
    },
  ];

  const adminMenuItems: any = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: `${t("MENU:DASHBOARD")}`,
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    {
      id: "users",
      label: `${t("MENU:USERS")}`,
      icon: "ri-user-line",
      link: "/users",
      stateVariables: isUsers,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Users");
      },
    },
    {
      id: "file-management",
      label: `${t("MENU:FILE_MANAGEMENT")}`,
      icon: "ri-folders-line",
      link: "/apps-file-manager",
      stateVariables: isFileManagement,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("File Management");
      },
    },
    {
      id: "agent",
      label: `${t("MENU:AGENT")}`,
      icon: "ri-chat-1-line",
      link: "/chat",
      stateVariables: isAgent,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Agent");
      },
    },
    {
      id: "notifications",
      label: `${t("MENU:NOTIFICATIONS")}`,
      icon: "ri-notification-line",
      link: "/notifications",
      stateVariables: isNotification,
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Notifications");
      },
    },
  ];

  const menuItems =
    user?.role === "SUPERADMIN" || user?.role === "MANAGER"
      ? adminMenuItems
      : memberMenuItems;
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
